import React, { useEffect, useState } from "react";
import { getCurrentTrip } from "../../../services/TransportService";
import { convertTime } from "../../../utilities";
import format from "date-fns/format";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
const CurrentTrip = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    setLoading(true);
    getCurrentTrip()
      .then((res) => {
        setData(res?.data?.bus_data);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  if (error) {
    return <div className="m-2 alert alert-danger">{error}</div>;
  }
  return (
    <>
      <div>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Current Trips
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Currents Trips
              </li>
            </ol>
          </div>
        </div>
        <div className="card mt-2">
          {/* <div className="d-flex flex-column flex-sm-row justify-content-end gap-2 px-2 py-3">
              <div className="flex-fill flex-md-grow-0">
                <small>Select Route</small>
                <Select
                  options={routeOption}
                  onChange={setSelectedroute}
                  placeholder="Select Route"
                  className="react-select"
                  classNamePrefix="select"
                  isClearable
                  value={selecetdroute}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
              <div className="flex-fill flex-md-grow-0">
                <small>Select Bus</small>
                <Select
                  options={busOption}
                  onChange={setSelectedBus}
                  placeholder="Select Route"
                  className="react-select"
                  classNamePrefix="select"
                  isClearable
                  value={selectedBus}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
              <div className="flex-fill flex-md-grow-0">
                <small>Select Shift</small>
                <Select
                  options={shiftOption}
                  onChange={setSelectedshift}
                  placeholder="Select Route"
                  className="react-select"
                  classNamePrefix="select"
                  isClearable
                  value={selectedshift}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 999,
                    }),
                  }}
                />
              </div>
            </div> */}
          {loading ? (
            <div className="text-center my-2">
              <Spinner animation="border" />
            </div>
          ) : data?.length > 0 ? (
            <div
              className="table-responsive"
              style={{ maxHeight: "350px", overflowY: "auto" }}
            >
              <table class="table table-borderless fs-6 mb-0">
                <thead
                  class="table-light custom-thead sticky-top"
                  style={{ zIndex: "1", top: "0" }}
                >
                  <tr>
                    <th>Bus</th>
                    <th>Route</th>
                    <th>Duration</th>
                    <th>Mode</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    const tripModeClass =
                      item?.trip_mode?.toLowerCase() === "pickup"
                        ? "text-bg-success-soft"
                        : "text-bg-info-soft";
                    return (
                      <tr>
                        <td>
                          <div>
                            <span
                              className="text-primary fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.bus?.number_plate || "N/A"}
                            </span>
                            <br></br>
                            <span
                              className="text-dark fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.driver?.name || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          {" "}
                          <div>
                            <span
                              className="text-primary fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.route?.name || "N/A"}
                            </span>
                            <br></br>
                            <span
                              className="text-dark fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.shift?.name || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              className="text-dark fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.start_time
                                ? format(
                                    convertTime(item?.start_time),
                                    "hh:mm a"
                                  )
                                : "N/A"}
                              -{" "}
                              {item?.end_time
                                ? format(convertTime(item?.end_time), "hh:mm a")
                                : "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${tripModeClass}`}>
                            {item?.trip_mode || "N/A"}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-2">No Data Found</div>
          )}
        </div>
      </div>
    </>
  );
};

export default CurrentTrip;
